<ng-container *ngIf="enableAccessibility">
  <div class="my-2 px-3 w-100">
      <div class="modal-header-right ml-auto">
          <button type="button" class="close" (click)="disableFilter.emit()" aria-label="Close filter panel">
              <i class="icon-close" aria-hidden="true"></i>
          </button>
      </div>
  </div>
  <div class="filter-title-container px-3 w-100 mt-2 py-2">
      <span style="font-size: 20px; color:#000000; font-weight: bold;">Filters</span>
      <button type="button" class="btn btn-primary" (click)="applyFilters()" aria-label="Apply selected filters to map"> Apply Filters</button>
  </div>
</ng-container>
<ng-container *ngIf="!enableAccessibility">
  <div class="my-2 px-3 w-100">
      <div class="modal-header-right ml-auto">
          <button type="button" class="close" (click)="disableFilter.emit()">
              <i class="icon-close"></i>
          </button>
      </div>
  </div>
  <div class="filter-title-container px-3 w-100 mt-2 py-2">
      <span style="font-size: 20px; color:white; font-weight: bold;">Filters</span>
      <button type="button" class="btn btn-primary" (click)="applyFilters()"> Apply Filters</button>
  </div>
</ng-container>
<div class="filter-item-container px-3 w-100 py-2" *ngIf="isMapInteractive">
    <span style="font-size: 20px; font-weight: bold;"><i style="color: #00000061;" class="icon-funnel"></i></span>
    <span style="font-size: 20px; font-weight: bold;">{{ getFilterTitle() }}</span>
    <span style="font-size: 25px; font-weight: bold;" title="Reset Filters and Layers" ><i *ngIf="totalRecords !== filteredRecord || form?.value?.Layer" style="color: #00000061;" (click)="resetMap()" (keydown)="$event.preventDefault()" class="icon-refresh"></i></span>
</div>
<div class="px-3 w-100 h-75" *ngIf="!isMapInteractive">
    <div class="my-3">
        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="filterSearch">
    </div>
    <div style="overflow: scroll; height: 90%;">
        <ng-container *ngFor="let data of getFilterFieldData(filterSearch); index as i">
            <div *ngIf="data" class="custom-control custom-checkbox custom-checkbox-new custom-checkbox-un-01">
                <input type="checkbox" id="checkbox-{{ i }}" [checked]="isFieldInFilterData(data)"
                    (change)="filtermapData(data)" class="custom-control-input">
                <label class="custom-control-label custom-checkbox-label d-flex align-items-center" for="checkbox-{{ i }}"><i
                        class="icon-location mr-2" style="font-size: 30px;"
                        [ngStyle]="{'color' : getColorForValue(data ? data : '')}"></i>{{ data ? data : '(_blank)'}}</label>
            </div>
        </ng-container>
    </div>
</div>
<div class="px-3 w-100 mt-2" *ngIf="isMapInteractive">
    <div class="row" *ngIf="mapReportData?.MapTemplates?.length">
        <app-select
            [form]="form"
            controlName="Layer"
            [options]="mapTemplates"
            label="Select Map Layer"
            class="form-group col"
            (selected)="onLayerSelection()"
        ></app-select>
    </div>
    <div class="row" *ngIf="mapReportData?.SeriesField1Key">
        <app-select
            *ngIf="mapReportData?.SeriesField1Key && mapReportData?.SeriesField1.FieldType !== 'INT' && mapReportData?.SeriesField1.FieldType !== 'DOUBLE' && mapReportData?.SeriesField1.FieldType !== 'DECIMAL(20,2)' && mapReportData?.SeriesField1.FieldType !== 'DATE' && mapReportData?.SeriesField1.FieldType !== 'DATETIME'"
            [form]="form"
            controlName="Filter1"
            [options]="filter1Options"
            [label]="mapReportData?.SeriesField1.Name"
            [multiple]="true"
            class="form-group col"
        ></app-select>
        <div [formGroup]="form" class="form-group col mb-4" *ngIf="mapReportData?.SeriesField1Key && (mapReportData?.SeriesField1.FieldType === 'INT' || mapReportData?.SeriesField1.FieldType === 'DOUBLE' || mapReportData?.SeriesField1.FieldType === 'DECIMAL(20,2)')">
            <div class="d-flex">
                <label style="font-size: 14px; font-weight: 400;">{{ mapReportData?.SeriesField1.Name }}</label>
            </div>
            <div class="form-group-control d-flex justify-content-between">
                <span class="slider-min">{{ getMinData('SeriesField1')}}</span>
                <input type="range" class="form-control slider" [min]="getMinData('SeriesField1')" [max]="getMaxData('SeriesField1')" formControlName="Filter1">
                <output class="slider-tooltip" for="Filter1">{{ form.value.Filter1 || (getMinData('SeriesField1') + getMaxData('SeriesField1'))/2 }}</output>
                <span class="slider-max">{{ getMaxData('SeriesField1')}}</span>
            </div>
        </div>
        <div [formGroup]="form" class="form-group col mb-2" *ngIf="mapReportData?.SeriesField1.FieldType === 'DATE' || mapReportData?.SeriesField1.FieldType === 'DATETIME'">
            <div class="d-flex">
                <label style="font-size: 14px; font-weight: 400;">{{ mapReportData?.SeriesField1.Name }}</label>
            </div>
            <div class="form-group-control">
                <app-input 
                    [form]="form"
                    controlName="Filter1"
                    class="form-group"
                    [type]="'date'"
                ></app-input>
                <app-input 
                    [form]="form"
                    controlName="Filter12"
                    class="form-group"
                    [type]="'date'"
                ></app-input>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="mapReportData?.SeriesField2Key">
        <app-select
            *ngIf="mapReportData?.SeriesField2Key && mapReportData?.SeriesField2.FieldType !== 'INT' && mapReportData?.SeriesField2.FieldType !== 'DOUBLE' && mapReportData?.SeriesField2.FieldType !== 'DECIMAL(20,2)' && mapReportData?.SeriesField2.FieldType !== 'DATE' && mapReportData?.SeriesField2.FieldType !== 'DATETIME'"
            [form]="form"
            controlName="Filter2"
            [options]="filter2Options"
            [label]="mapReportData?.SeriesField2.Name"
            [multiple]="true"
            class="form-group col"
        ></app-select>
        <div [formGroup]="form" class="form-group col mb-4" *ngIf="mapReportData?.SeriesField2Key && (mapReportData?.SeriesField2.FieldType === 'INT' || mapReportData?.SeriesField2.FieldType === 'DOUBLE' || mapReportData?.SeriesField2.FieldType === 'DECIMAL(20,2)')">
            <div class="d-flex">
                <label style="font-size: 14px; font-weight: 400;">{{ mapReportData?.SeriesField2.Name }}</label>
            </div>
            <div class="form-group-control d-flex justify-content-between">
                <span class="slider-min">{{ getMinData('SeriesField2')}}</span>
                <input type="range" class="form-control slider" [min]="getMinData('SeriesField2')" [max]="getMaxData('SeriesField2')" formControlName="Filter2">
                <output class="slider-tooltip" for="Filter2">{{ form.value.Filter2 || (getMinData('SeriesField2') + getMaxData('SeriesField2'))/2 }}</output>
                <span class="slider-max">{{ getMaxData('SeriesField2')}}</span>
            </div>
        </div>
        <div [formGroup]="form" class="form-group col mb-2" *ngIf="mapReportData?.SeriesField2.FieldType === 'DATE' || mapReportData?.SeriesField2.FieldType === 'DATETIME'">
            <div class="d-flex">
                <label style="font-size: 14px; font-weight: 400;">{{ mapReportData?.SeriesField2.Name }}</label>
            </div>
            <div class="form-group-control">
                <app-input 
                    [form]="form"
                    controlName="Filter2"
                    class="form-group"
                    [type]="'date'"
                ></app-input>
                <app-input 
                    [form]="form"
                    controlName="Filter22"
                    class="form-group"
                    [type]="'date'"
                ></app-input>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="mapReportData?.SeriesField3Key">
        <app-select
            *ngIf="mapReportData?.SeriesField3Key && mapReportData?.SeriesField3.FieldType !== 'INT' && mapReportData?.SeriesField3.FieldType !== 'DOUBLE' && mapReportData?.SeriesField3.FieldType !== 'DECIMAL(20,2)' && mapReportData?.SeriesField3.FieldType !== 'DATE' && mapReportData?.SeriesField3.FieldType !== 'DATETIME'"
            [form]="form"
            controlName="Filter3"
            [options]="filter3Options"
            [label]="mapReportData?.SeriesField3.Name"
            [multiple]="true"
            class="form-group col"
        ></app-select>
        <div [formGroup]="form" class="form-group col mb-4" *ngIf="mapReportData?.SeriesField3Key && (mapReportData?.SeriesField3.FieldType === 'INT' || mapReportData?.SeriesField3.FieldType === 'DOUBLE' || mapReportData?.SeriesField3.FieldType === 'DECIMAL(20,2)')">
            <div class="d-flex">
                <label style="font-size: 14px; font-weight: 400;">{{ mapReportData?.SeriesField3.Name }}</label>
            </div>
            <div class="form-group-control d-flex justify-content-between">
                <span class="slider-min">{{ getMinData('SeriesField3')}}</span>
                <input type="range" class="form-control slider" [min]="getMinData('SeriesField3')" [max]="getMaxData('SeriesField3')" formControlName="Filter3">
                <output class="slider-tooltip" for="Filter3">{{ form.value.Filter3 || (getMinData('SeriesField3') + getMaxData('SeriesField3'))/2 }}</output>
                <span class="slider-max">{{ getMaxData('SeriesField3')}}</span>
            </div>
        </div>
        <div [formGroup]="form" class="form-group col mb-2" *ngIf="mapReportData?.SeriesField3.FieldType === 'DATE' || mapReportData?.SeriesField3.FieldType === 'DATETIME'">
            <div class="d-flex">
                <label style="font-size: 14px; font-weight: 400;">{{ mapReportData?.SeriesField3.Name }}</label>
            </div>
            <div class="form-group-control">
                <app-input 
                    [form]="form"
                    controlName="Filter3"
                    class="form-group"
                    [type]="'date'"
                ></app-input>
                <app-input 
                    [form]="form"
                    controlName="Filter32"
                    class="form-group"
                    [type]="'date'"
                ></app-input>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!isLimitExceed">
        <span *ngFor="let data of markerColorField" class="mx-1 my-1 d-flex align-items-center"><i
            class="icon-location mr-2" style="font-size: 30px;"
            [ngStyle]="{'color' : getColorForValue(data ? data : '')}"></i>{{ data ? data : '(_blank)'}}</span>
    </div>
</div>